import cookieValue from './cookieValue';
import setCookie from './setCookie';

/**
 * Get the recent systems list from cookie
 * @returns {Array} Array of system node IDs, ordered from most recent to least recent
 */
const getRecentSystems = () => {
    const cookie = cookieValue('recentSystems');
    if (!cookie || !cookie.systems || !Array.isArray(cookie.systems)) {
        return [];
    }
    return cookie.systems;
};

/**
 * Add a system to the recent systems list
 * Moves existing systems to the top, maintains unique list
 * @param {string} nodeId - The node identifier of the system
 * @param {number} maxCount - Maximum number of systems to store
 * @returns {boolean} Returns true if cookie was updated, false if consent not granted
 */
const addRecentSystem = (nodeId, maxCount = 3) => {
    // Check for Cookiebot consent
    if (!window.Cookiebot || !window.Cookiebot.consent || !window.Cookiebot.consent.preferences) {
        return false;
    }

    // Get current list
    let systems = getRecentSystems();

    // Remove the system if it already exists (to move it to top)
    systems = systems.filter((id) => id !== nodeId);

    // Add the system to the beginning of the array (most recent)
    systems.unshift(nodeId);

    // Enforce max count limit (remove oldest entries)
    if (systems.length > maxCount) {
        systems = systems.slice(0, maxCount);
    }

    // Store updated list
    const cookieData = {
        systems: systems,
        updated: Date.now(),
    };

    // Get expiration days from configuration (fallback to 30)
    const expirationDays = 30; // This will be overridden by the component's data attribute if available

    setCookie('recentSystems', cookieData, expirationDays);
    return true;
};

/**
 * Clear the recent systems list
 */
const clearRecentSystems = () => {
    document.cookie = 'recentSystems=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

export { getRecentSystems, addRecentSystem, clearRecentSystems };
